import React, { useEffect, useRef, useState } from 'react'

import style from './style.module.scss'
import useSurveyLocale from '../../modules/locale/useSurveyLocale'
import useViewport from '../../modules/viewport/useViewport'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import TextWithOptions from '../../modules/preview/components/TextWithOptions'
import usePreviewOptions from '../../modules/preview/usePreviewOptions'

interface IExitSimulationProps {
  setClosed: () => void
  setExternalHint?: (value: boolean) => void
  needExternalHint?: boolean
  onSetCloseHint?: () => void
  hintText?: string | React.ReactNode
  className?: string
}
const ExitSimulation = ({
  setClosed,
  hintText,
  needExternalHint,
  setExternalHint,
  onSetCloseHint,
  className
}: IExitSimulationProps) => {
  const { t } = useSurveyLocale()
  const viewport = useViewport()

  const hasHintContent = 'string' === typeof hintText ? hintText.length > 0 : React.isValidElement(hintText)
  const [needHint, setNeedHint] = useState<boolean>(hasHintContent && needExternalHint)

  const cachedNumber = useRef(0)
  if (false == needHint) cachedNumber.current += 1

  const previewOptions = usePreviewOptions()

  const setHint = (value: boolean) => {
    if (!value && 'function' == typeof onSetCloseHint) onSetCloseHint()
    if ('function' == typeof setExternalHint) setExternalHint(value)
    setNeedHint(value)
  }

  useEffect(() => {
    if (needExternalHint && hasHintContent) setNeedHint(needExternalHint)
  }, [hasHintContent, needExternalHint])

  return (
    <div
      className={`${style.exitSimulationContainer} ${viewport.mobile ? style.emobilContainer : ''} ${className || ''}`}
    >
      <TransitionGroup>
        <CSSTransition key={cachedNumber.current} timeout={500}>
          <div className={style.hintContainer} style={{ display: needHint ? 'block' : 'none' }}>
            <div className={style.hint}>
              {'string' === typeof hintText ? (
                <TextWithOptions text={hintText} options={{ ...previewOptions, showLogic: false }} />
              ) : // <span dangerouslySetInnerHTML={{ __html: hintText ? hintText.replace('<br/>null', '') : '' }} />
              React.isValidElement(hintText) ? (
                <span>{hintText}</span>
              ) : null}
              <button onClick={() => setHint(false)}>{t('questions', 'gotIt')}</button>
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>

      {!setExternalHint ? (
        <button className={`${style.exitSimulation} ${viewport.mobile ? style.emobile : ''}`}>
          {hasHintContent ? (
            <>
              <i className="icon-aytmfd-help" onClick={() => setHint(true)} /> |&nbsp;&nbsp;
            </>
          ) : (
            ''
          )}
          <span onClick={setClosed}>{t('questions', 'exitSimulation')}</span>
        </button>
      ) : (
        ''
      )}
    </div>
  )
}

export default ExitSimulation
